var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignHorizontalRight = function SvgAlignHorizontalRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 8,
    fill: "currentColor",
    rx: 0.667,
    transform: "matrix(0 1 1 0 2.667 4.667)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 5.333,
    fill: "currentColor",
    rx: 0.667,
    transform: "matrix(0 1 1 0 5.333 8.667)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.333V2.667a.667.667 0 0 1 1.333 0v10.666a.667.667 0 1 1-1.333 0"
  })));
};
export default SvgAlignHorizontalRight;